export default async(modul_id,actualRoom,settings) =>
{
    console.log('%c 🛫 Instant-Login Module Loaded! ', 'background: #222; color: #bada55');
}
